import { defineStore } from 'pinia'

export const useCommentsStore = defineStore('comments', {
    state: () => ({
        comments: [],
        pagination: {
            pages: 0,
            page: 1
        },
        lastCommentId: null
    }),
    actions: {
        /**
         * Загрузка комментариев
         *
         * @returns {Promise<void>}
         */
        loadComments(taskId, context) {
            var $this = this,
                params = {
                    page: this.pagination.page
                };

            return context.postToServer('tasks/comments/' + taskId, params, function (resp) {
                if (resp.data.result !== undefined) {
                    $this.comments = [...resp.data.result.items.reverse(), ...$this.comments];
                    $this.pagination.pages = resp.data.result.pages;
                }

                return resp;
            });
        }
    }
})